/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const ChatIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M15.945 1.2c3.165.001 4.782.036 5.8 1.054.982.982 1.05 2.52 1.055 5.468v6.636c-.004 1.314-.032 2.036-.274 2.62a3.6 3.6 0 01-1.948 1.948c-.584.242-1.306.27-2.62.274h-.745c-.472 0-.735.005-.99.046a3.6 3.6 0 00-1.094.365c-.257.135-.494.313-.969.669l-2.096 1.572c-.104.078-.155.117-.2.144a1.2 1.2 0 01-1.657-.391c-.095-.19-.256-.503-.305-.589a3.6 3.6 0 00-2.93-1.81 16.903 16.903 0 00-.45-.003l-.24.001-.261.001h-.252c-.97-.001-1.487-.015-1.916-.132a3.6 3.6 0 01-2.526-2.526c-.107-.393-.124-.86-.127-1.682L1.201 7.4c.01-2.738.108-4.2 1.053-5.146C3.31 1.2 5.006 1.2 8.4 1.2h7.545zm-.022 2.4H8.4c-1.765 0-2.847.005-3.63.11-.689.093-.804.225-.817.24l-.002.001v.002l-.016.015c-.04.047-.146.22-.225.802-.092.685-.107 1.6-.11 3v7.01c.001.364.004.618.013.823.01.196.023.279.028.304l.001.009c.1.364.364.658.71.797l.132.045c-.009-.003.052.017.313.029.205.01.459.012.822.013h.645l.236.001c.25.001.52.003.603.008a6 6 0 014.481 2.403l1.136-.852c.384-.289.861-.647 1.295-.875a5.997 5.997 0 011.824-.607c.484-.08.968-.079 1.449-.078h.547a23.73 23.73 0 001.371-.029c.341-.023.443-.058.453-.062a1.2 1.2 0 00.65-.65c.004-.01.039-.112.062-.453.022-.32.027-.726.029-1.322V7.769c-.003-1.4-.018-2.314-.11-3-.079-.582-.185-.754-.225-.801l-.016-.017h-.002c-.013-.016-.128-.148-.817-.24-.734-.1-1.73-.11-3.307-.111zm-.323 7.2c1.988 0 2.4.537 2.4 1.2 0 .663-.412 1.2-2.4 1.2H8.4C6.412 13.2 6 12.663 6 12c0-.663.412-1.2 2.4-1.2h7.2zm0-4.8c1.988 0 2.4.537 2.4 1.2 0 .663-.412 1.2-2.4 1.2H8.4C6.412 8.4 6 7.863 6 7.2 6 6.537 6.412 6 8.4 6h7.2z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
ChatIconSvg.displayName = 'ChatIconSvg'

const ChatIcon = forwardRef((props, ref) => <Icon component={ChatIconSvg} ref={ref} {...props} />)
ChatIcon.displayName = 'ChatIcon'

ChatIcon.defaultProps = {
	...Icon.defaultProps,
}
ChatIcon.propTypes = {
	...Icon.propTypes,
}

export default ChatIcon
export { ChatIconSvg }
